import { jsx } from "panel";
export function template() {
  const { t } = this.getContext(`i18n`);
  const timerText = this.helpers.getLastRefreshRelativeFormat();
  const isCompact = this.attr(`is-compact`);
  return /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".last-updated-container",
      attrs: {
        elref: `timeDisplayContainer`
      },
      class: { "is-compact": isCompact }
    },
    isCompact ? timerText : t(`components.last-updated.updated`, { relativeTime: timerText })
  );
}
